import axios from 'axios';
import Account from './helpers/Account.js';
import {REACT_APP_API_URL} from './config.js';
// import {lang} from "./translate";
const api = axios.create({
    baseURL: REACT_APP_API_URL,
    'Access-Control-Allow-Origin': REACT_APP_API_URL,
});
const uploadApi = axios.create({
    baseURL: REACT_APP_API_URL,
});

api.interceptors.request.use(
    (config) => {
        config.headers = {
            Authorization: `Bearer ${Account.getToken()}`,
        };
        return config;
    },
    (error) => Promise.reject(error) // Forward the error

);
api.interceptors.response.use(
    (response) => response, // Return response as is
    (error) => {
        if (error.response && error.response.status === 401) {
            Account.logoutAdmin(); // Call your logout function
            window.location.pathname = "/employee"; // Redirect to login page
        }
        return Promise.reject(error); // Forward the error
    }
);


const {id, profession} = Account.getData()

class Api {
    //-------USER--------//
    static login(form, pref) {
        return axios.post(`${REACT_APP_API_URL}login/${pref}`, {...form});
    }

    static emailVerification(form) {
        return axios.post(`${REACT_APP_API_URL}send-email-verification-code/`, {...form});
    }

    static checkEmailVerification(form) {
        return axios.post(`${REACT_APP_API_URL}check-email-verification-code/`, {...form});
    }

    static changePassword(form) {
        return axios.put(`${REACT_APP_API_URL}change-existing-password/`, {...form});
    }

    static profileManager(prof) {
        return api.get(`${Account.getData().profession}/me`,);
    }

    static notification() {
        return api.get(`get-new-task-count/`,);
    }

    static managerUpdate(form, man_profession, man_id) {
        return api.put(`${man_profession ? man_profession : profession}/${man_id ? man_id : id}/`, form);
    }

    static managerUpdateGet(man_profession, man_id) {
        return api.get(`${man_profession ? man_profession : profession}/${man_id ? man_id : id}/`,);
    }

    //------TASK------//
    static todayTaskSum() {
        return api.get(`todays-task-sum/${Account.getData().id}/${Account.getData().profession}`,);
    }

    static taskTemplate() {
        return api.get(`task-template/?limit=1000`,);
    }

    static taskData(query) {
        // return api.get(`client-task/?${query || ''}`, );
        return api.get(`clients-task-mini/?role=${Account.getData().profession || "accountant"}&${query || ''}`,);

    }

    static getManager(query) {
        return api.get(`manager/?${query || ''}`,);
    }

    static getCompaniesTitle() {
        return api.get(`get_companies_title/`,);
    }

    static getAccountTitle() {
        return api.get(`accountant-task/`,);
    }

    static changeTimerById(data, id) {
        return api.put(`client-task-timer/${id}/`, data);
    }

    static getTaskSingle(id) {
        return api.get(`client-task/${id}/`,);
    }

    static createTask(formData) {
        formData.append("status", "approved")
        return api.post(`client-task/`, formData);
    }

    static createMultipleTask(formData) {
        formData.append("status", "approved")
        return api.post(`multi-task/`, formData);
    }

    static editTask(formData, id) {
        return api.put(`client-task/${id}/`, formData);
    }

    static deleteTask(id) {
        return api.delete(`client-task/${id}/`);
    }

    static patchTask(formData, id) {
        return api.patch(`client-task/${id}/`, formData);
    }

    static clientRate(formData) {
        return api.post(`client-rate/`, formData);
    }

    //------TIMER------//
    static timer(data) {
        return api.post(`client-task-timer/`, data);
    }

    static editStatus(id, start_or_end,) {
        return api.post(`${start_or_end}/${id}/`, {id});
    }

    //------ACCOUNTANT TEAM------//
    static getTeam() {
        return api.get(`groups/`);
    }

    static moveTeam({accountant_id, target_group_id}) {
        return api.patch(`groups/move_accountant/`, {
            accountant_id,
            target_group_id
        });
    }


    //------TASK SMS------//
    static sendMessage(form) {
        return api.post(`client-task-sms/`, form);
    }

    static getMessage(id, form) {
        return api.post(`get-task-smses/${id}/`, form);
    }

    static seenMessage(id) {
        return api.post(`set-task-smses-seen/${id}/`);
    }

    //------TASK FILES------//

    static getTaskFiles(id) {
        return api.post(`get-task-smses-only-file/${id}/`, {for_all: null});
    }

    static setTaskFiles(id) {
        return api.post(`set-task-files-seen/${id}/`, {});
    }

    static createTaskFiles(form) {
        return api.post(`client-task-file/`, form);
    }

    static deleteTaskFiles(url) {
        return api.delete(url);
    }

    //-----COMPANY ORGANIZATION----//
    static deletedCompanies() {
        return api.get(`get-deleted-companies-count/`,);
    }

    static companyServices() {
        return api.get(`company-service/`,);
    }

    static companyManager(query) {
        return api.get(`manager-company/?${query ? query : ''}`,);
    }

    static companySingle(id) {
        return api.get(`manager-company/${id}/`,);
    }

    static getConnectedCompanies(prof, id, limit) {
        return api.get(`client-company/?${prof || Account.getData().profession}=${id || Account.getData().id}&limit=${limit}`,);
    }

    static packages() {
        return axios.get(`${REACT_APP_API_URL}packages/`,);
    }

    static activityType() {
        return api.get(`type-of-activity/`,);
    }

    static taxSystem() {
        return api.get(`taxation-system/`,);
    }

    static updateCompanies(id, form) {
        return api.put(`client-company/${id}/`, form);
    }

    static deleteCompanies(id,) {
        return api.post(`manager/set/deleted/company`, {id});
    }

    //------STUFF------//
    static getStuff() {
        return api.get("accountant-types/",);
    }

    static getStuffByType(accountant_type, limit) {
        return api.get(`accountant/?accountant_type=${accountant_type}&limit=${limit}`,);
    }

    static getAllStuff() {
        return api.get(`accountant/?&limit=1000`,);
    }

    static getStuffManagerByType(accountant_type) {
        return api.get(`manager/?accountant_type=${accountant_type}`,);
    }

    static createAccount(form) {
        return api.post(`accountant/`, form);
    }

    static deleteAccount(id) {
        return api.delete(`accountant/${id}/`,);
    }

    //--------CLIENT------//
    static clientGet(offset, search) {
        return api.get(`clients-mini/?offset=${offset || ''}&search=${search || ''}`,);
    }

    static clientSingle(id) {
        return api.get(`client/${id}/`,);
    }

    static clientDelete(id) {
        return api.delete(`client/${id}/`,);
    }

    // ------- ARCHIVE ------ //
    static archivedTaskGet(params, query) {
        const add_accountant_empty = params.accountant === "" && params.manager ? query += "&accountant=" : query;
        const add_accountant_null = params.accountant === null && params.manager ? query += "&accountant_null=true" : add_accountant_empty;
        return api.get(`client-task/?${add_accountant_null || ''}`,);
    }

    static setArchive(data) {
        return api.post(`manager/set/archive`, data);
    }

    //------REPEATED TASKS------//
    static repeatedTasks(query) {
        return api.get(`repeated-task/?${query}`,);
    }

    static repeatedSingleTasks(id) {
        return api.get(`repeated-task/${id}/`,);
    }

    static createRepeatedTask(form) {
        return api.post(`repeated-task/`, form);
    }

    static editRepeatedTask(id, form) {
        return api.put(`repeated-task/${id}/`, form);
    }

    static createRepeatedTaskMany(form) {
        return api.post(`multi-repeated-task/`, form);
    }

    static deleteRepeatTask(id) {
        return api.delete(`repeated-task/${id}/`);
    }

    //---------NOTIFICATION-------//
    static getNotification(query) {
        return api.get(`manager-notification/?${query}`);
    }

    static getNotificationCount(query) {
        return api.get(`manager-notification/count/?${query}`);
    }

    static getNotificationSingle(id) {
        return api.get(`manager-notification/${id}/`);
    }

    static setSeenAll(type) {
        return api.post(`/notify-seen/?type=${type || ''}`);
    }

    static putNotificationSingle(id, data) {
        return api.put(`manager-notification/${id}/`, data, {headers: {"Content-type": "application/json",}});
    }

    static deleteNotification(id) {
        return api.delete(`manager-notification/${id}/`);
    }

    static createNotification(form) {
        return api.post(`manager-notification/`, form);
    }

    static createNotificationComment(form) {
        return api.post(`manager-notification-comment/`, form);
    }

    //--------REPORT-----//
    static getReport(id, start, end, title) {
        return api.get(`report/${id}/${start}/${end}/${title}/json/`);
    }

    //------FILES------//
    static getFiles(params) {
        return api.get(`company-file/${params}`);
    }

    static deleteFile(id) {
        return api.delete(`company-file/${id}/`);
    }

    static postFile(form) {
        return api.post(`company-file/`, form);
    }

    //-----NOTES-------//
    static getNotes(querystring) {
        return api.get(`accountant-note/?accountant=${id}${querystring}`);
    }

    static deleteNote(id) {
        return api.delete(`accountant-note/${id}/`);
    }

    static addNote(form) {
        return api.post(`accountant-note/`, form);
    }

    //-----DAY OFF-------//
    static getDayOff(querystring = '') {
        return api.get(`dayoff/?${querystring}`);
    }

    static dayOffCount() {
        return api.get(`dayoff-count/`);
    }

    static deleteDayOff(id) {
        return api.delete(`dayoff/${id}/`);
    }

    static statusDayOff(id, approved) {
        return api.patch(`dayoff/${id}/`, approved);
    }

    static addDayoff(form) {
        return api.post(`dayoff/`, form);
    }

    //-------PASSWORD-------//
    static passwordRequest(form) {
        return axios.post(`${REACT_APP_API_URL}reset-request/`, form);
    }

    static passwordVerify(form) {
        return axios.post(`${REACT_APP_API_URL}reset-verify/`, form);
    }

    static passwordEnter(form) {
        return axios.post(`${REACT_APP_API_URL}reset-enter/`, form);
    }

    //-----NOTIFY-------//
    static getNotify() {
        return api.get(`notify/`);
    }

    static updateNotify(id) {
        return api.patch(`notify/`, {notification_id: id});
    }

    //-----SURVEY-------//
    static getSurvey(querystring) {
        return api.get(`surveys/?${querystring}`);
    }
    static getSurveyCount() {
        return api.get(`surveys/draft_count/`);
    }
    static getSurveySingle(id) {
        return api.get(`surveys/${id}/`);
    }

    static getSurveyMessage(id) {
        return api.get(`surveys/${id}/messages/`);
    }

    static postSurveyMessage(id,form) {
        return api.post(`surveys/${id}/messages/`, form);
    }
    static deleteSurvey(id) {
        return api.delete(`surveys/${id}/`);
    }
    static deleteSurveyFile(id,file) {
        return api.delete(`surveys/${id}/attachments/${file}/`);
    }
    static createSurvey(form) {
        return api.post(`surveys/`, form);
    }
    static updateSurvey(id,form) {
        return api.put(`surveys/${id}/`, form);
    }
    static updateSurveyStatus(id,form) {
        return api.patch(`surveys/${id}/`, form);
    }

    static createSurveyFile(id,form) {
        return api.post(`surveys/${id}/attachments/`, form);
    }


    //------EVENTS-----//

    static getEvents(querystring,user) {
        return api.get(`events/?type=${querystring}${user?"&user_ids=" + user:""}`);
    }

    static createEvent(form) {
        return api.post(`events/`, form);
    }
    static editEvent(form,id) {
        return api.put(`events/${id}/`, form);
    }
    static deleteEvent(id) {
        return api.delete(`events/${id}/`,);
    }
   

    //-------CHAT------//
    static getContact() {
        return api.get(`messages/team/`,);
    }
    static getRooms() {
        return api.get(`messages/rooms/`,);
    }
    static getChatMessage(id) {
        return api.get(`messages/rooms/${id}/`,);
    }
    static createChatMessage(id,form) {
        return api.post(`messages/rooms/${id}/create/`,form);
    }
    static seenChatMessage(id,) {
        return api.post(`messages/${id}/seen/`,);
    }
    static createRoom(form) {
        return api.post(`messages/rooms/create/`,form);
    }


    //------AGENT------//
    static gerAgentList(id) {
        return api.get(`agents/`,);
    }
    static sendMessageAgent(form) {
        return api.post(`agent/sms/`,form);
    }
    static getMessageAgent(id) {
        return api.get(`agent/sms/?task=${id}`);
    }
    static gerAgentTaskList() {
        return api.get(`agent/task-type/`,);
    }
    static createAgentTask(form) {
        return api.post(`agent-tasks/`,form);
    }
    static getAgentTask({page,status,title,amount_min,amount_max,comapny,agent}) {
        return api.get(`agent-tasks/?offset=${page || ''}&status=${status || ""}&title=${title || ""}&amount_min=${amount_min || ""}&amount_max=${amount_max || ""}&company=${comapny || ''}&agent=${agent || ""}`,);
    }
    static getAgentTaskFiles(id) {
        return api.get(`agent-tasks-files/?task_id=${id}`,);
    }
    static deleteAgentTaskFiles(id) {
        return api.delete(`agent-tasks-files/${id}/`,);
    }
    static getAgentTaskFiles(id) {
        return api.get(`agent-tasks-files/?task_id=${id}`,);
    }
    static getAgentTaskSingle(id) {
        return api.get(`agent-tasks/${id}/`,);
    }
    static updateAgentTask(id, data) {
        return api.patch(`agent-tasks/${id}/`, data);
    }
    static deleteAgentTask(id) {
        return api.delete(`agent-tasks/${id}/`);
    }
    static setAgentTaskPurchasesPayed(id) {
        return api.post(`agent-tasks/${id}/set-purchases-payed/`);
    }
    static rejectAgentTask(id, data) {
        return api.post(`agent-tasks/${id}/reject/`, data);
    }
    static getUnpaidCompletedTasks(params = {}) {
        const companyParam = Array.isArray(params.company) && params.company.length > 0 
            ? params.company.map(id => `company=${id}`).join('&')
            : '';
        const agentParam = Array.isArray(params.agent) && params.agent.length > 0 
            ? params.agent.map(id => `agent=${id}`).join('&')
            : '';
        return api.get(`agent-tasks/unpaid-completed/?start_date=${params.start_date || ""}&end_date=${params.end_date || ""}${companyParam ? '&' + companyParam : ''}${agentParam ? '&' + agentParam : ''}`);
    }
    static createAgentTaskAllow(form) {
        return api.post(`user-task-permissions/`,form);
    }
    static createAgentTaskFile(form) {
        return api.post(`task-files/`,form);
    }
    static validateAcceptAgentTask(query) {
        return api.get(`agent-task/access${query}`);
    }
    static acceptAgentTask(form) {
        return api.post(`agent-task/access`,form);
    }
    static getAgentTaskAllow() {
        return api.get(`user-task-permissions/`,);
    }
    static getAgentTaskTimer() {
        return api.get(`agent-task-timers/today/`,);
    }
    static startAgentTaskTimer(form) {
        return api.post(`agent-task-timers/`,form);
    }
    static endAgentTaskTimer(id) {
        return api.post(`agent-tasks/${id}/complete/`,);
    }
    static stopAgentTaskTimer(id) {
        return api.post(`agent-task-timers/${id}/stop/`,);
    }
    static AgentTaskTimer(id) {
        return api.get(`agent-task-timers/${id}/`,);
    }
    static deleteAgentTaskAllow(id) {
        return api.delete(`user-task-permissions/${id}/`,);
    }
    //------PURCHASE-----//
    static agentPurchase(id,form) {
        return api.patch(`purchases/${id}/set_status/`,form);
    }
    static agentPurchaseAdd(form) {
        return api.post(`purchases/`,form);
    }
    static getPurchaseMinMax() {
        return api.get(`purchases/min-max-status1/`,);
    }
    static getPurchase(params = {}) {
        return api.get(`purchases/agent-active/?start_date=${params.start_date || ""}&end_date=${params.end_date || ""}&amount_min=${params.amount_min || ""}&amount_max=${params.amount_max || ""}${params.agent ? "&agent=" + params.agent : ""}`,);
    }
    static setPurchasePayed(id) {
        return api.patch(`purchases/${id}/set-payed/`);
    }

}

export default Api